const EXCLUDED_CODES = new Set(['mc_freetrial-5-thryv-m2m'])

export function transformProducts(productConfigInfo) {
  // OOE-UI-FZ: a `= {}` parameter default only covers `undefined`, so the
  // store's null productConfig (its value until the catalog request lands)
  // fell straight through and threw "Cannot read properties of null (reading
  // 'centers')" inside the memoized selector.
  const {centers = [], apps = [], oneTimeFees = []} = productConfigInfo || {}
  // Only one-time fees with no `appliesTo` are directly browsable/selectable
  // (e.g. Professional Designed Logo, 5 Extra Website Pages) — ones with
  // appliesTo rules (e.g. Website Design Fee, Onboarding Fee) are backend
  // auto-attach fees driven by other selections (see reconcileFees in
  // useProductsCatalog.js) and must stay out of the grid entirely.
  const browsableOneTimeFees = oneTimeFees.filter(fee => !fee.appliesTo?.length)
  const all = [...centers, ...apps, ...browsableOneTimeFees]

  const groupMap = {}
  all.forEach(product => {
    const key = product.uigroup
    if (!key || key.toLowerCase() === 'hidden') return
    if (EXCLUDED_CODES.has(product.code)) return
    // if (product.productBillingType === 'Annual') return
    if (!groupMap[key]) {
      groupMap[key] = {
        firstProduct: product,
        items: [],
      }
    }
    groupMap[key].items.push(product)
  })

  const groups = Object.values(groupMap).map(({firstProduct, items}) => {
    const sorted = [...items].sort(
      (a, b) => (a.productSeq ?? 0) - (b.productSeq ?? 0),
    )
    const plans = sorted.map(p => ({...p}))

    return {
      id: firstProduct.uigroup,
      name: firstProduct.uigroup,
      prod_type: firstProduct.prod_type,
      plans,
    }
  })

  groups.sort((a, b) => {
    const aSeq = groupMap[a.id].firstProduct.groupSeq ?? 0
    const bSeq = groupMap[b.id].firstProduct.groupSeq ?? 0
    return aSeq - bSeq
  })

  return groups
}
